import React from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { FormField, Spinner } from '@legalshield/adonis-ux-framework';

import { useLanguages } from '../queriesClient';
import { LanguageOption } from '../types';
import SearchWithDropDown, { DropDownOption } from './SearchWithDropDown';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  required?: boolean;
};

const LanguagesSearchSelect = <T extends FieldValues>({ control, name, required }: Props<T>) => {
  const { data, isLoading, isError } = useLanguages();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const selected = (field.value as LanguageOption[] | undefined) ?? [];

        if (isLoading) {
          return (
            <FormField id={String(name)} label="Languages" required={required}>
              <Spinner />
            </FormField>
          );
        }
        if (isError) {
          return (
            <FormField id={String(name)} label="Languages" required={required}>
              <p className="rnq-error">Could not load languages.</p>
            </FormField>
          );
        }

        const options: DropDownOption[] = (data ?? []).map((d) => ({
          title: d.title,
          value: d.value,
        }));

        return (
          <SearchWithDropDown
            label="Languages"
            required={required}
            multipleChoice
            multiSize="small"
            options={options}
            value={selected.map((s) => ({ title: s.title, value: s.value }))}
            onChange={(next) => field.onChange(next)}
          />
        );
      }}
    />
  );
};

export default LanguagesSearchSelect;
